module.exports = __webpack_public_path__ + "img/ezgif.com-apng-maker-2.f70f134b.png";